import React, { Component } from 'react'
import './electrocardiogram.scss'
import { Menu, Dropdown, Modal, Tabs, TimePicker, InputNumber } from 'antd'
import moment from 'moment'
import { segmentsIntr } from '../../common/util'
const { TabPane } = Tabs;
export default class Electrocardiogram extends Component {
  state = {
    //实时的时间
    time: moment().format('HH:mm:ss'),
    //屏幕的高
    vHeight: 0,
    //监控的人数
    monitorNum: 0,
    childrenWidth: 583,
    //走纸速度
    paperSpeed: '25',
    //波形增益
    sensitivity: '10',
    //显示模式
    displayModel: '3',
    //增益mv率
    transmission: 180,
    //采样率
    sampling: 125,
    beatObj: {
      // 'aabbccdd': {
      //   name: '张三',
      //   sex: '男',
      //   age: 10,
      //   hospital: '申请医院',
      //   dataNum: 0,
      //   dataList: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      //   startPointY: 0,
      //   endPointY: 0,
      //   pointX: 0,
      //   pointLog: [],
      // },
      // 'kkfkkggj': {
      //   name: '李四',
      //   sex: '女',
      //   age: 30,
      //   hospital: '会诊医院',
      //   dataNum: 0,
      //   dataList: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      //   startPointY: 0,
      //   endPointY: 0,
      //   pointX: 0,
      //   pointLog: [],
      // }
    },
    devicesList: [],
    //一秒走125个数据
    intervalTime: 1000 / 125,
    settingModalBtn: false,
    activeBigKey: '1',
    settingJson: {
      bpmJSon: {
        startTime1: '06:00',
        endTime1: '20:00',
        minBpm1: 50,
        maxBpm1: 100,
        startTime2: '20:00',
        endTime2: '06:00',
        minBpm2: 20,
        maxBpm2: 60,
      }
    },
    bpmArray: [50, 53, 65, 120],
    stArray: [0.1, -0.1, 0.2, -0.2, 0.3, -0.3, 0.4, -0.4, 0.5, -0.5, 0.6, -0.6, 0.7, -0.7, 0.03, 0.05, 0.01, -0.03, -0.04],
    bloodArray: [120, 80, 115, 78, 130, 90, 122, 82, 120, 80, 115, 78, 130, 90, 122, 82, 120, 80, 115, 78, 130, 90, 122, 82],
    temperatureArray: [35, 36.3, 35.5, 37, 37, 39, 40, 42, 38.9, 38.5, 38],
    //是否是第一次进
    bpmFirstIn: true,
    stFirstIn: true,
    bloodFirstIn: true,
    temperatureFirstIn: true,
  }
  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState({
        time: moment().format('HH:mm:ss')
      })
    }, 1000)
    this.changeChildrenWidth(parseInt(this.state.displayModel));
    window.onresize = this.onResize;
    this.onResize();
    this.getData();
    this.ecgTimer = setInterval(() => {
      this.drawLine()
    }, this.state.intervalTime)
    this.isAlarm(30)
    this.drawBpmCanvas();
    this.drawStCanvas();
    this.drawBloodCanvas();
    this.drawTemperatureCanvas();
    this.bpmTimer = setInterval(() => {
      let bpmArray = this.state.bpmArray;
      let value = Math.floor(Math.random() * 60 + 50);
      bpmArray.push(value)
      if (bpmArray.length >= 110) {
        bpmArray.shift();
      }
      this.setState({
        bpmArray
      }, () => {
        this.drawBpmCanvas()
        // this.drawStCanvas()
      })
    }, 1000)
    this.stTimer = setInterval(() => {
      let stArray = this.state.stArray;
      let value = Math.random().toFixed(2)
      if (value > 0.4) {
        value = -(value - 0.4)
      }
      stArray.push(value)
      if (stArray.length >= 28) {
        stArray.shift();
      }
      this.setState({
        stArray
      }, () => {
        this.drawStCanvas()
      })
    }, 1000)
    this.bloodTimer = setInterval(() => {
      let bloodArray = this.state.bloodArray;
      let value = Math.random() * 99 + 80;
      bloodArray.push(value);
      bloodArray.push(value - 40);
      if (bloodArray.length >= 25) {
        bloodArray = bloodArray.slice(2)
      }
      this.setState({
        bloodArray
      }, () => {
        this.drawBloodCanvas()
      })
    }, 1000)
    this.temperatureTimer = setInterval(() => {
      let list = this.state.temperatureArray;
      let value = Math.random() * 5 + 33 + Math.random();
      list.push(value.toFixed(1));
      if (list.length >= 110) {
        list.shift();
      }
      this.setState({
        temperatureTimer: list
      }, () => {
        this.drawTemperatureCanvas();
      })
    }, 1000)
  }
  componentWillUnmount() {
    clearInterval(this.timer)
    clearInterval(this.ecgTimer)
  }
  getData = () => {
    let ws = new WebSocket('ws://192.168.1.104:9998');
    ws.onopen = () => {
      ws.send('注册:devices');
    }
    ws.onmessage = (evt) => {
      var blob = new Blob([evt.data])
      var fr = new FileReader();
      fr.addEventListener("load", (ev) => {
        var abb = ev.target.result;
        var iAA = new Int8Array(abb);
        //  console.log((iAA[5] & 255) | (iAA[4] << 8) | (iAA[3] << 16) | (iAA[2] << 24), '数据长度')
        if (iAA[0] === -1 && iAA[1] === -1) {
          if (iAA[6] === 2) {
            this.decodeUserInfo(iAA)
          } else if (iAA[6] === 1) {
            this.decodeUserData(iAA)
          } else if (iAA[6] === 3) {
            this.deleteUser(iAA)
          }
        }
      });
      fr.readAsArrayBuffer(blob)
    }
  }
  //utf-8字节转字符
  utf8ByteToUnicodeStr = (utf8Bytes) => {
    var unicodeStr = "";
    for (var pos = 0; pos < utf8Bytes.length;) {
      var flag = utf8Bytes[pos];
      var unicode = 0;
      if ((flag >>> 7) === 0) {
        unicodeStr += String.fromCharCode(utf8Bytes[pos]);
        pos += 1;

      } else if ((flag & 0xFC) === 0xFC) {
        unicode = (utf8Bytes[pos] & 0x3) << 30;
        unicode |= (utf8Bytes[pos + 1] & 0x3F) << 24;
        unicode |= (utf8Bytes[pos + 2] & 0x3F) << 18;
        unicode |= (utf8Bytes[pos + 3] & 0x3F) << 12;
        unicode |= (utf8Bytes[pos + 4] & 0x3F) << 6;
        unicode |= (utf8Bytes[pos + 5] & 0x3F);
        unicodeStr += String.fromCharCode(unicode);
        pos += 6;

      } else if ((flag & 0xF8) === 0xF8) {
        unicode = (utf8Bytes[pos] & 0x7) << 24;
        unicode |= (utf8Bytes[pos + 1] & 0x3F) << 18;
        unicode |= (utf8Bytes[pos + 2] & 0x3F) << 12;
        unicode |= (utf8Bytes[pos + 3] & 0x3F) << 6;
        unicode |= (utf8Bytes[pos + 4] & 0x3F);
        unicodeStr += String.fromCharCode(unicode);
        pos += 5;

      } else if ((flag & 0xF0) === 0xF0) {
        unicode = (utf8Bytes[pos] & 0xF) << 18;
        unicode |= (utf8Bytes[pos + 1] & 0x3F) << 12;
        unicode |= (utf8Bytes[pos + 2] & 0x3F) << 6;
        unicode |= (utf8Bytes[pos + 3] & 0x3F);
        unicodeStr += String.fromCharCode(unicode);
        pos += 4;

      } else if ((flag & 0xE0) === 0xE0) {
        unicode = (utf8Bytes[pos] & 0x1F) << 12;;
        unicode |= (utf8Bytes[pos + 1] & 0x3F) << 6;
        unicode |= (utf8Bytes[pos + 2] & 0x3F);
        unicodeStr += String.fromCharCode(unicode);
        pos += 3;

      } else if ((flag & 0xC0) === 0xC0) { //110
        unicode = (utf8Bytes[pos] & 0x3F) << 6;
        unicode |= (utf8Bytes[pos + 1] & 0x3F);
        unicodeStr += String.fromCharCode(unicode);
        pos += 2;

      } else {
        unicodeStr += String.fromCharCode(utf8Bytes[pos]);
        pos += 1;
      }
    }
    return unicodeStr;
  }
  //解析个人信息
  decodeUserInfo = (buffer) => {
    if (buffer[0] === -1 && buffer[1] === -1) {
      let { devicesList, beatObj, monitorNum } = this.state;
      //取出来设备号
      let device = this.utf8ByteToUnicodeStr(buffer.slice(7, 19))
      if (!beatObj[device]) {
        beatObj[device] = {}
        devicesList.push(device)
        monitorNum++;
      }
      //姓名的坐标
      let nameIndex = buffer.indexOf(0, 19);
      //性别的坐标
      let sexIndex = buffer.indexOf(0, nameIndex + 1);
      //年龄的坐标
      let ageIndex = buffer.indexOf(0, sexIndex + 1);
      //医院的坐标
      let hospitalIndex = buffer.indexOf(0, ageIndex + 1);
      beatObj[device].name = this.utf8ByteToUnicodeStr(buffer.slice(19, nameIndex));
      beatObj[device].sex = this.utf8ByteToUnicodeStr(buffer.slice(nameIndex + 1, sexIndex));
      beatObj[device].age = this.utf8ByteToUnicodeStr(buffer.slice(sexIndex + 1, ageIndex));
      beatObj[device].hospital = this.utf8ByteToUnicodeStr(buffer.slice(ageIndex + 1, hospitalIndex));
      //存上画图需要用的初始值
      beatObj[device].dataNum = 0;
      beatObj[device].dataList = [];
      beatObj[device].startPointY = 0;
      beatObj[device].endPointY = 0;
      beatObj[device].pointX = 0;
      beatObj[device].pointLog = [];
      beatObj[device].heartRate = 0;
      this.setState({
        beatObj,
        devicesList,
        monitorNum
      }, () => {
        if (buffer.slice(hospitalIndex + 1).length > 0) {
          this.decodeUserInfo(buffer.slice(hospitalIndex + 1))
        }
        this.drawGrid();
      })
    }
  }
  //解析数据
  time1 = 0
  decodeUserData = (buffer) => {
    if (buffer[0] === -1 && buffer[1] === -1) {
      let { beatObj, intervalTime } = this.state;
      let device = this.utf8ByteToUnicodeStr(buffer.slice(7, 19));
      let dataNum = (buffer[22] & 255) | (buffer[21] << 8) | (buffer[20] << 16) | (buffer[19] << 24);
      let heartRate = (buffer[24] & 255) | (buffer[23] << 8)
      let time2 = new Date().getTime();
      console.log('数据：' + buffer.slice(25).length, '时间：' + (time2 - this.time1))
      console.log(this.time1, time2)
      this.time1 = time2;
      if (beatObj[device]) {
        let arr = buffer.slice(25);
        for (var i = 0; i < arr.length; i += 2) {
          beatObj[device].dataList.push((arr[i] << 8) | (arr[i + 1] & 255))
        }
        beatObj[device].dataNum = dataNum;
        beatObj[device].dataTime = dataNum * 5;
        if (heartRate !== 0) {
          beatObj[device].heartRate = heartRate
        }
        console.log((beatObj[device].dataList.length) - (buffer.slice(25).length) / 2)
        let CachePool = (beatObj[device].dataList.length) - (buffer.slice(25).length) / 2;
        if (CachePool >= 250) {
          console.log('快进版')
          clearInterval(this.ecgTimer)
          intervalTime -= 1;
          this.ecgTimer = setInterval(() => {
            this.drawLine()
          }, intervalTime)
        } else if (CachePool < 250 && CachePool >= 125) {
          console.log('正常版')
          clearInterval(this.ecgTimer)
          this.ecgTimer = setInterval(() => {
            this.drawLine()
          }, this.state.intervalTime)
        } else {
          console.log('慢速版')
          clearInterval(this.ecgTimer)
          intervalTime += 1;
          this.ecgTimer = setInterval(() => {
            this.drawLine()
          }, intervalTime)
        }
        this.setState({
          beatObj
        })
      }
    }
  }

  //删除个人信息
  deleteUser = (buffer) => {
    let { devicesList, beatObj, monitorNum } = this.state;
    if (buffer[0] === -1 && buffer[1] === -1) {
      let device = this.utf8ByteToUnicodeStr(buffer.slice(7, 19));
      let messageId = buffer.indexOf(0, 19)
      let message = this.utf8ByteToUnicodeStr(buffer.slice(19, messageId))
      if (message === 'remove') {
        devicesList.splice(devicesList.map(item => item).indexOf(device), 1)
        delete beatObj[device]
        monitorNum--
        this.setState({
          devicesList,
          beatObj,
          monitorNum
        }, () => {
          if (buffer.slice(messageId + 1).length > 0) {
            this.deleteUser(buffer.slice(messageId + 1))
          }
        })
      }
    }
  }
  onResize = () => {
    let vHeight = document.body.clientHeight;
    this.setState({
      vHeight
    }, () => {
      this.changeChildrenWidth(parseInt(this.state.displayModel));
    })
  }
  //切换显示方式，算出来每个应该有多宽
  changeChildrenWidth = (num) => {
    let width = document.body.clientWidth;
    if (width > 1260) {
      width = width - width * 0.02
      let childrenWidth = parseInt(width / num - 40);
      this.setState({
        childrenWidth
      }, () => {
        this.drawGrid()
      })
    }
  }
  //心电图背景
  drawGrid = () => {
    let devicesList = this.state.devicesList;
    devicesList.forEach(item => {
      let ecgCanvas = document.getElementById(item);
      if (ecgCanvas && ecgCanvas.getContext) {
        let ctx = ecgCanvas.getContext('2d');
        let width = ecgCanvas.width - 5;
        let height = ecgCanvas.height;
        ctx.clearRect(0, 0, width, height)
        for (let x = 0.5; x <= width; x += 5) {
          if ((x - 0.5) % 25 === 0) {
            ctx.beginPath();
            ctx.lineWidth = 1;
            ctx.strokeStyle = '#454545';
            ctx.moveTo(x, 0);
            ctx.lineTo(x, height);
            ctx.stroke();
            ctx.closePath();
          } else {
            ctx.beginPath();
            ctx.lineWidth = 1;
            ctx.strokeStyle = '#353535';
            for (let z = 0; z <= height; z += 5) {
              if (z % 25 !== 0) {
                ctx.moveTo(x + 1, z + 1);
                ctx.lineTo(x - 1, z - 1);
              }
            }
            ctx.stroke();
            ctx.closePath();
          }
        }
        for (let y = 0.5; y <= height; y += 25) {
          ctx.beginPath();
          ctx.lineWidth = 1;
          ctx.strokeStyle = '#454545';
          ctx.moveTo(0, y);
          ctx.lineTo(width, y);
          ctx.stroke();
          ctx.closePath();
        }
      }
    })

  }
  //画线
  drawLine = () => {
    let { devicesList, beatObj, paperSpeed, sensitivity, transmission, sampling, } = this.state;
    //根据数据给我的1mv的高度和选择的增益算出来我在屏幕上应该显示多高百分比
    transmission = (sensitivity * 5) / transmission;
    //根据走纸速度和采样率选择我应该取的值，算出来步进应该取第几个值
    let speed = sampling / (paperSpeed * 5);
    //let speed = 1;
    devicesList.forEach(item => {
      let nowOperation = beatObj[item];
      if (nowOperation.dataList.length > speed) {
        let ecgCanvas = document.getElementById(item);
        if (ecgCanvas && ecgCanvas.getContext) {
          let ctx = ecgCanvas.getContext('2d');
          let width = ecgCanvas.width;
          let height = ecgCanvas.height;
          //以画布的中点开始画
          nowOperation.startPointY = height / 2;
          //如果x轴走完了整个画布，就从头开始画
          if (nowOperation.pointX >= width) {
            nowOperation.pointX = 0
          }
          //删除上一次画的，并且添加一个断点背景
          ctx.beginPath();
          ctx.strokeStyle = '#FFF'
          ctx.lineWidth = 2;
          ctx.clearRect(nowOperation.pointX, 0, 20, height)
          ctx.moveTo(nowOperation.pointX + 10, 0)
          ctx.lineTo(nowOperation.pointX + 10, height)
          ctx.stroke();
          ctx.closePath();
          //补充背景只补充画到的x轴的位置和之前删除的掉的10个位置
          for (let x = nowOperation.pointX + 0.5; x <= nowOperation.pointX + 10; x += 5) {
            if ((x - 0.5) % 25 === 0) {
              ctx.beginPath();
              ctx.lineWidth = 1;
              ctx.strokeStyle = '#454545';
              ctx.moveTo(x, 0);
              ctx.lineTo(x, height);
              ctx.stroke();
              ctx.closePath();
            }
            if ((x - 0.5) % 5 === 0) {
              ctx.beginPath();
              ctx.lineWidth = 1;
              ctx.strokeStyle = '#353535';
              for (let z = 0; z <= height; z += 5) {
                if (z % 25 !== 0) {
                  ctx.moveTo(x + 1, z + 1);
                  ctx.lineTo(x - 1, z - 1);
                }
              }
              ctx.stroke();
              ctx.closePath();
            }
          }
          for (let y = 0.5; y <= height; y += 25) {
            ctx.beginPath();
            ctx.lineWidth = 1;
            ctx.strokeStyle = '#454545';
            ctx.moveTo(nowOperation.pointX, y);
            ctx.lineTo(nowOperation.pointX + 8, y);
            ctx.stroke();
            ctx.closePath();
          }
          //画心电波
          ctx.beginPath();
          ctx.strokeStyle = "green";
          ctx.lineWidth = 1.3;
          ctx.lineCap = "round";
          ctx.lineJoin = "round";
          //如果x轴坐标到0的位置证明从头开始画，直接定位到开始的坐标，这样就不会从结尾到开始画一条线
          if (nowOperation.pointX === 0) {
            ctx.moveTo(0, nowOperation.startPointY);
            nowOperation.pointLog = [];
          } else {
            //写一个画的日志是为了让他中间不存在两条线之间好像没有连接上的问题
            if (nowOperation.pointLog.length === 3) {
              ctx.moveTo(nowOperation.pointLog[1].x, nowOperation.pointLog[1].y)
            } else {
              ctx.moveTo(nowOperation.pointX, nowOperation.endPointY)
            }
          }
          //采样率125正好5个像素一格，如果是50mm就要两格画一个像素
          if (speed === 0.5) {
            nowOperation.pointX += 2
          } else {
            nowOperation.pointX++;
          }
          if (typeof nowOperation.intervalTime !== 'undefined') {
            nowOperation.intervalTime++;
          } else {
            nowOperation.intervalTime = 0;
          }
          if (nowOperation.intervalTime >= this.state.sampling) {
            nowOperation.dataTime++;
            nowOperation.intervalTime = 0;
          }
          //拿到数据以后算一下应该在y轴的那个位置，
          nowOperation.endPointY = nowOperation.startPointY - nowOperation.dataList[Math.ceil(speed)] * transmission;
          //重复一下上次画的路径防止中间断点
          if (nowOperation.pointLog[2] && nowOperation.pointX !== 0) {
            ctx.lineTo(nowOperation.pointLog[2].x, nowOperation.pointLog[2].y)
          }
          //再写一遍是为了重复上一次画的时候到最后，这样之前定义的就白费了
          if (nowOperation.pointX === 0) {
            ctx.moveTo(0, nowOperation.endPointY)
          }
          ctx.lineTo(nowOperation.pointX, nowOperation.endPointY)
          //把每次画的位置都存起来
          nowOperation.pointLog.push({ 'x': nowOperation.pointX, 'y': nowOperation.endPointY })
          //只存3次的数据，多余的从头开始删掉
          if (nowOperation.pointLog.length > 3) {
            nowOperation.pointLog.shift()
          }
          //画一个点，从数据里面删除一个点
          nowOperation.dataList.splice(0, Math.ceil(speed))
          // if(nowOperation.dataList.length % 10 === 0){
          //   console.log(nowOperation.dataList.length)
          // }
          ctx.stroke();
          ctx.closePath();
          this.setState({
            beatObj
          }, () => {
            //  console.log(this.state.beatObj)
          })
        }
      }
    })
  }
  //走纸速度
  handlePaperClick = (e) => {
    this.setState({
      paperSpeed: e.key,
    })
  }
  //波形增益
  handleWaveClick = (e) => {
    this.setState({
      sensitivity: e.key
    })
  }
  //显示模式
  handleMenuClick = (e) => {
    this.setState({
      displayModel: e.key
    }, () => {
      this.changeChildrenWidth(parseInt(this.state.displayModel))
    })
  }
  //时间转换
  transformationTime = (time) => {
    return moment('2021-01-01 00:00:00').add(time, 'seconds').format('HH:mm:ss');
  }
  //设置弹框
  settingModal = () => {

    let localSettingJson = localStorage.getItem('settingJson');
    let settingJson = this.state.settingJson;
    // if (bpmJson) {
    //   bpmJson = JSON.parse(bpmJson)
    //   bpmJson.startTime1 = localSettingJson.startTime1 || '06:00';
    //   bpmJson.endTime1 = localSettingJson.endTime1 || '20:00';
    //   bpmJson.minBpm1 = localSettingJson.minBpm1 || 50;
    //   bpmJson.maxBpm1 = localSettingJson.maxBpm1 || 100;
    //   bpmJson.startTime2 = localSettingJson.startTime2 || '20:00';
    //   bpmJson.endTime2 = localSettingJson.endTime2 || '06:00';
    //   bpmJson.minBpm2 = localSettingJson.minBpm2 || 20;
    //   bpmJson.maxBpm2 = localSettingJson.maxBpm2 || 60;
    // }
    this.setState({
      settingModalBtn: true,
      settingJson: localSettingJson ? localSettingJson : settingJson,
    })
  }
  cancelSettingModal = () => {
    this.setState({
      settingModalBtn: false,
    })
  }
  changeTabBox = (e) => {
    this.setState({
      activeBigKey: e
    })
  }
  changeBpmTime = (value, type, e) => {
    let settingJson = this.state.settingJson
    if (type === 'time') {
      settingJson = Object.assign({}, settingJson, { [value]: moment(e).format('HH:mm') })
    } else {
      settingJson = Object.assign({}, settingJson, { [value]: type })
    }
    this.setState({
      settingJson
    }, () => {
      console.log(this.state.settingJson)
    })
  }
  settingJsonOk = () => {
    localStorage.setItem('settingJson', JSON.stringify(this.state.settingJson))
    this.cancelSettingModal()
  }
  //判断心率是否报警
  isAlarm = (bpm) => {
    let nowTime = moment().format('HH:mm');
    let settingJson = JSON.parse(localStorage.getItem('settingJson'));
    if (settingJson) {
      let isAlarm = false;
      if (settingJson.startTime1 < nowTime && nowTime < settingJson.endTime1) {
        if ((bpm < settingJson.minBpm1) || (bpm > settingJson.maxBpm1)) {
          isAlarm = true;
        }
      }
      if (settingJson.startTime2 < nowTime || nowTime < settingJson.endTime2) {
        if ((bpm < settingJson.minBpm2) || (bpm > settingJson.maxBpm2)) {
          isAlarm = true;
        }
      }
      return isAlarm;
    } else {
      return false
    }
  }
  //获取设置的bpm
  getSettingBpm = () => {
    let nowTime = moment().format('HH:mm');
    let settingJson = JSON.parse(localStorage.getItem('settingJson'));
    let settingBpm = [];
    if (settingJson) {
      if (settingJson.startTime1 < nowTime && nowTime < settingJson.endTime1) {
        settingBpm = [settingJson.minBpm1, settingJson.maxBpm1];
      }
      if (settingJson.startTime2 < nowTime || nowTime < settingJson.endTime2) {
        settingBpm = [settingJson.minBpm2, settingJson.maxBpm2];
      }
    }
    return settingBpm;
  }
  //心率走势图
  drawBpmCanvas = () => {
    let canvas = document.getElementById('bpmCanvas');
    let maxBpm = this.getSettingBpm()[1] || 130;
    let minBpm = this.getSettingBpm()[0] || 50;
    console.log(maxBpm, minBpm)
    if (canvas.getContext) {
      let ctx = canvas.getContext('2d');
      let width = canvas.width;
      let height = canvas.height;
      if (this.state.bpmFirstIn) {
        ctx.translate(0.5, 0.5)
        this.setState({ bpmFirstIn: false })
      }
      //console.log(width,height)  //128  65
      ctx.clearRect(-5, -5, width, height)
      //两条边线
      ctx.strokeStyle = '#FFF'
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(15, 10);
      ctx.lineTo(15, height - 10);
      ctx.lineTo(width - 10, height - 10);
      ctx.stroke();
      ctx.closePath();

      //最低值和最高值的界限
      ctx.beginPath();
      ctx.strokeStyle = '#F00'
      // ctx.lineWidth = 1;
      for (let i = 15; i < width - 10; i += 10) {
        ctx.moveTo(i, parseInt(height - minBpm / 4))
        ctx.lineTo(i + 6, parseInt(height - minBpm / 4))
        ctx.moveTo(i, parseInt(height - maxBpm / 4))
        ctx.lineTo(i + 6, parseInt(height - maxBpm / 4))
      }
      ctx.stroke();
      ctx.closePath();

      //画线
      ctx.beginPath();
      let bpmArray = this.state.bpmArray;
      ctx.strokeStyle = 'green'
      ctx.moveTo(16, parseInt(height - bpmArray[0] / 4))
      for (let i = 1; i < bpmArray.length; i++) {
        ctx.lineTo(16 + i, parseInt(height - bpmArray[i] / 4));
      }
      ctx.stroke();
      ctx.closePath();
    }
  }
  //st间隙走势图
  drawStCanvas = () => {
    let canvas = document.getElementById('stCanvas');
    if (canvas.getContext) {
      let ctx = canvas.getContext('2d');
      let width = canvas.width - 10;
      let height = canvas.height - 10;
      let baseline = parseInt((height + 10) / 2);
      if (this.state.stFirstIn) {
        ctx.translate(0.5, 0.5)
        this.setState({ stFirstIn: false })
      }
      //console.log(width,height)  //128  65
      ctx.clearRect(0, 0, width + 10, height + 10)
      //两条边线加中间的界限
      ctx.strokeStyle = '#FFF'
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(15, 10);
      ctx.lineTo(15, height);
      ctx.lineTo(width, height);
      ctx.moveTo(15, baseline);
      ctx.lineTo(width, baseline);
      ctx.stroke();
      ctx.closePath();
      //画线

      let pointX = 19;
      let stArray = this.state.stArray;
      // console.log(stArray)
      // console.log(baseline)
      for (let i = 0; i < stArray.length; i++) {

        let baseline = parseInt((height + 10) / 2);
        if (stArray[i] > 0) {
          baseline -= 1
        } else {
          baseline += 1;
        }
        if (stArray[i] > 0 && stArray[i] > 0.3) {
          //如果大于0并且大于设定的值，那么超出的变红
          ctx.beginPath();
          ctx.strokeStyle = 'green';
          ctx.lineWidth = 3;
          ctx.moveTo(pointX, baseline)
          ctx.lineTo(pointX, baseline - 0.3 * 70);
          ctx.stroke();
          ctx.closePath();

          ctx.beginPath();
          ctx.strokeStyle = 'red';
          ctx.lineWidth = 3;
          ctx.moveTo(pointX, baseline - 0.3 * 70)
          if (stArray[i] >= 0.4) {
            ctx.lineTo(pointX, baseline - (0.4 * 70 + 1));
          } else {
            ctx.lineTo(pointX, baseline - stArray[i] * 70);
          }
          ctx.stroke();
          ctx.closePath();
        } else if (stArray[i] < 0 && stArray[i] < -0.1) {
          //如果小于0并且小于设定的值，那么超出的变红
          ctx.beginPath();
          ctx.strokeStyle = 'green';
          ctx.lineWidth = 3;
          ctx.moveTo(pointX, baseline)
          ctx.lineTo(pointX, baseline + 0.1 * 70);
          ctx.stroke();
          ctx.closePath();

          ctx.beginPath();
          ctx.strokeStyle = 'red';
          ctx.lineWidth = 3;
          ctx.moveTo(pointX, baseline + 0.1 * 70)
          if (stArray[i] <= -0.4) {
            ctx.lineTo(pointX, baseline - (-0.4 * 70 + 2));
          } else {
            ctx.lineTo(pointX, baseline - stArray[i] * 70);
          }

          ctx.stroke();
          ctx.closePath();
        } else {
          ctx.beginPath();
          ctx.strokeStyle = 'green';
          ctx.lineWidth = 3;
          ctx.moveTo(pointX, baseline)
          ctx.lineTo(pointX, baseline - stArray[i] * 70);
          ctx.stroke();
          ctx.closePath();
        }
        pointX += 4;
      }

    }
  }
  //血压走势图
  drawBloodCanvas = () => {
    let canvas = document.getElementById('bloodCanvas');
    let maxBaseline = 120;
    let minBaseline = 80;
    if (canvas.getContext) {
      let ctx = canvas.getContext('2d');
      let width = canvas.width;
      let height = canvas.height;
      if (this.state.bloodFirstIn) {
        ctx.translate(0.5, 0.5)
        this.setState({ bloodFirstIn: false })
      }
      //console.log(width,height)  //128  65
      ctx.clearRect(-5, -5, width, height)
      //两条边线加中间的界限
      ctx.strokeStyle = '#FFF'
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(15, 10);
      ctx.lineTo(15, height - 10);
      ctx.lineTo(width - 10, height - 10);
      ctx.stroke();
      ctx.closePath();

      //基线
      let maxHeight = height - (maxBaseline - 30);
      let minHeight = height - (minBaseline - 30);
      ctx.beginPath();
      ctx.strokeStyle = '#F00'
      // ctx.lineWidth = 1;
      for (let i = 15; i < width - 10; i += 10) {
        ctx.moveTo(i, minHeight)
        ctx.lineTo(i + 6, minHeight)
        ctx.moveTo(i, maxHeight)
        ctx.lineTo(i + 6, maxHeight)
      }
      ctx.stroke();
      ctx.closePath();

      ctx.textAlign = 'right';
      ctx.fillStyle = '#fff';
      ctx.textBaseline = 'middle';
      ctx.font = '11px "SimSun"';
      ctx.fillText(maxBaseline, 14, maxHeight)
      ctx.fillText(minBaseline, 14, minHeight)
      //画线

      let pointX = 19;
      let list = this.state.bloodArray;
      for (let i = 0; i < list.length; i += 2) {
        //先处理一下数据，都减去30算原点
        let highPressure1 = height - (list[i] - 30);
        let lowPressure1 = height - (list[i + 1] - 30);
        let highPressure2 = height - (list[i + 2] - 30);
        let lowPressure2 = height - (list[i + 3] - 30);
        //高压线
        ctx.beginPath();
        ctx.strokeStyle = '#FFF'
        ctx.lineWidth = 1;
        ctx.moveTo(pointX, highPressure1)
        ctx.lineTo(pointX + 10, highPressure2);

        //低压线
        ctx.moveTo(pointX, lowPressure1);
        ctx.lineTo(pointX + 10, lowPressure2);
        ctx.stroke();
        ctx.closePath();

        //高低中间连线
        ctx.beginPath();
        ctx.lineWidth = 1;
        ctx.strokeStyle = '#4D4D4D'
        ctx.moveTo(pointX, highPressure1 - 3)
        ctx.lineTo(pointX, lowPressure1 + 3)
        ctx.stroke();
        ctx.closePath();

        //高压标志圆点
        ctx.beginPath();
        ctx.arc(pointX, highPressure1, 3, Math.PI * 2, 0)
        ctx.fillStyle = 'red'
        ctx.fill();
        ctx.strokeStyle = "black";
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.closePath();

        //低压标志圆点
        ctx.beginPath();
        ctx.arc(pointX, lowPressure1, 3, Math.PI * 2, 0)
        ctx.fillStyle = 'green'
        ctx.fill();
        ctx.strokeStyle = "black";
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.closePath();

        pointX += 10;
      }
    }
  }
  //温度走势图
  drawTemperatureCanvas = () => {
    let canvas = document.getElementById('temperatureCanvas');
    let maxTemperature = 38;
    let minTemperature = 36;
    if (canvas.getContext) {
      let ctx = canvas.getContext('2d');
      let width = canvas.width;
      let height = canvas.height;
      if (this.state.temperatureFirstIn) {
        ctx.translate(0.5, 0.5)
        this.setState({ temperatureFirstIn: false })
      }
      //console.log(width,height)  //128  65
      let maxHeight = height - (maxTemperature - 30) * 10;
      let minHeight = height - (minTemperature - 30) * 10;
      ctx.clearRect(-5, -5, width, height)
      //两条边线和温度刻度
      ctx.strokeStyle = '#FFF'
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(15, 10);
      ctx.lineTo(15, height - 10);
      ctx.lineTo(width - 10, height - 10);
      ctx.stroke();
      ctx.closePath();

      ctx.textAlign = 'right';
      ctx.fillStyle = '#fff';
      ctx.textBaseline = 'middle';
      ctx.font = '11px "SimSun"';
      ctx.fillText(maxTemperature, 13, maxHeight)
      ctx.fillText(minTemperature, 13, minHeight)
      //最低值和最高值的界限
      ctx.beginPath();
      ctx.strokeStyle = '#F00'
      // ctx.lineWidth = 1;
      for (let i = 15; i < width - 10; i += 10) {
        ctx.moveTo(i, minHeight)
        ctx.lineTo(i + 6, minHeight)
        ctx.moveTo(i, maxHeight)
        ctx.lineTo(i + 6, maxHeight)
      }
      ctx.stroke();
      ctx.closePath();

      //封装画线的方法，下面会画好多线
      function drawLine(color, x1, y1, x2, y2) {
        ctx.beginPath();
        ctx.strokeStyle = color
        ctx.moveTo(x1, y1)
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.closePath();
      }
      //画线
      let list = this.state.temperatureArray;
      let pointX = 17;
      for (let i = 1; i < list.length; i++) {
        let y = height - (list[i - 1] - 30) * 10;
        let y1 = height - (list[i] - 30) * 10;
        //和设置的最高温度交点
        let heightBaseline = segmentsIntr({ x: pointX, y: y }, { x: pointX + 1, y: y1 }, { x: 17, y: maxHeight }, { x: width - 10, y: maxHeight });
        //和设置的最低温度交点
        let lowBaseline = segmentsIntr({ x: pointX, y: y }, { x: pointX + 1, y: y1 }, { x: 17, y: minHeight }, { x: width - 10, y: minHeight })
        if (heightBaseline && !lowBaseline) {
          //高温有交点，低温没有，则只需要判断是从高温外画的还是正常温度画的来区分先后顺序
          drawLine(heightBaseline.y > y ? 'red' : 'green', pointX, y, heightBaseline.x, heightBaseline.y)
          drawLine(heightBaseline.y > y ? 'green' : 'red', heightBaseline.x, heightBaseline.y, pointX + 1, y1)
        } else if (lowBaseline && !heightBaseline) {
          //低温有交点，高温没有，原理同上
          drawLine(lowBaseline.y < y ? 'red' : 'green', pointX, y, lowBaseline.x, lowBaseline.y)
          drawLine(lowBaseline.y < y ? 'green' : 'red', lowBaseline.x, lowBaseline.y, pointX + 1, y1)
        } else if (lowBaseline && heightBaseline) {
          //高低温都有交点判断两个值走势判断顺序
          if (y1 > y) {
            drawLine('red', pointX, y, heightBaseline.x, heightBaseline.y)
            drawLine('green', heightBaseline.x, heightBaseline.y, lowBaseline.x, lowBaseline.y)
            drawLine('red', lowBaseline.x, lowBaseline.y, pointX + 1, y1)
          } else {
            drawLine('red', pointX, y, lowBaseline.x, lowBaseline.y)
            drawLine('green', lowBaseline.x, lowBaseline.y, heightBaseline.x, heightBaseline.y)
            drawLine('red', heightBaseline.x, heightBaseline.y, pointX + 1, y1)
          }
        } else {
          //如果都没有交点，就直接画，就判断一下是否在设置的正常温度内，区分颜色
          let color = 'green'
          if (y1 < maxHeight || y < maxHeight || y1 > minHeight || y > minHeight) {
            color = 'red'
          }
          drawLine(color, pointX, y, pointX + 1, y1)
        }
        pointX++;
      }
    }
  }
  render() {
    const { paperSpeed, sensitivity, displayModel, devicesList, beatObj, settingJson: { bpmJSon } } = this.state;
    // 走纸速度
    const paperMenu = (
      <Menu onClick={this.handlePaperClick} selectedKeys={[String(paperSpeed)]}>
        <Menu.Item key="12.5">
          12.5 mm/s
        </Menu.Item>
        <Menu.Item key="25">
          25 mm/s
        </Menu.Item>
        <Menu.Item key="50">
          50 mm/s
        </Menu.Item>
      </Menu>
    );

    // 波形增益
    const waveMenu = (
      <Menu onClick={this.handleWaveClick} selectedKeys={[String(sensitivity)]}>
        <Menu.Item key="2.5">
          2.5 mm/mV
        </Menu.Item>
        <Menu.Item key="5">
          5 mm/mV
        </Menu.Item>
        <Menu.Item key="10">
          10 mm/mV
        </Menu.Item>
        <Menu.Item key="20">
          20 mm/mV
        </Menu.Item>
      </Menu>
    );

    // 显示模式
    const menu = (
      <Menu onClick={this.handleMenuClick} selectedKeys={[String(displayModel)]} className="menu_wrap">
        <Menu.Item key="1">
          1*1
        </Menu.Item>
        <Menu.Item key="2">
          1*2
        </Menu.Item>
        <Menu.Item key="3">
          1*3
        </Menu.Item>
        <Menu.Item key="4">
          1*4
        </Menu.Item>
        <Menu.Item key="5">
          1*5
        </Menu.Item>
      </Menu>
    );
    return (
      <div className="electrocardiogram" style={{ height: this.state.vHeight }}>
        <div className="settingBox">
          <div className="setting">
            <div >
              <Dropdown overlay={menu} trigger={['click']}>
                <p>显示</p>
              </Dropdown>
            </div>
            <div >
              <Dropdown overlay={paperMenu} trigger={['click']}>
                <p>走速</p>
              </Dropdown>
            </div>
            <div >
              <Dropdown overlay={waveMenu} trigger={['click']}>
                <p>增益</p>
              </Dropdown>
            </div>
            <div >
              <p onClick={this.settingModal}>设置</p>
            </div>
          </div>
        </div>
        <div className="headerTitle">
          <p className="title">远程实时监控系统</p>
          <p className="monitorNum">监测人数：<span>{this.state.monitorNum}</span></p>
          <p className="time">时间：<span>{this.state.time}</span></p>
        </div>
        <div className="content">
          <div className="contentBox">
            {devicesList.map((item, index) => (
              <div style={{ width: this.state.childrenWidth }} className="chilren" key={index}>
                <div className="topInfo">
                  <p className="title">
                    姓名：<span>{beatObj[item].name}</span>&nbsp;&nbsp;&nbsp;&nbsp;性别：{beatObj[item].sex}&nbsp;&nbsp;&nbsp;&nbsp;年龄：{beatObj[item].age}&nbsp;&nbsp;&nbsp;&nbsp;医院：{beatObj[item].hospital}
                  </p>
                  <div className={this.isAlarm(beatObj[item].heartRate) ? 'bpm bpmErr' : 'bpm'} id="bpm"><span>{beatObj[item].heartRate}</span>bpm</div>
                </div>
                <div className="ecgCanvas">
                  <canvas height="151px" width={this.state.childrenWidth + 'px'} id={item}></canvas>
                </div>
                <div className="botInfo">
                  <p>增益：{sensitivity}mv&nbsp;&nbsp;&nbsp;&nbsp;走速：{paperSpeed}mm&nbsp;&nbsp;&nbsp;&nbsp;记录时长：{this.transformationTime(beatObj[item].dataTime)}</p>
                </div>
              </div>
            ))}
            <div style={{ width: this.state.childrenWidth }} className="chilren">
              <div className="topInfo">
                <p className="title">
                  姓名：<span>张三</span>&nbsp;&nbsp;&nbsp;&nbsp;性别：男&nbsp;&nbsp;&nbsp;&nbsp;年龄：18&nbsp;&nbsp;&nbsp;&nbsp;医院：会诊医院
                </p>
                <div className={this.isAlarm(80) ? 'bpm bpmErr' : 'bpm'} id="bpm"><span>80</span>bpm</div>
              </div>
              <div className="ecgCanvas">
                <ul style={{ width: this.state.childrenWidth - 140 }}>
                  <li>
                    <p>2021.05.21</p>
                    <p>10:20:52</p>
                    <p><span>120/80</span>mmHg</p>
                  </li>
                  <li>
                    <p>2021.05.21</p>
                    <p>10:20:52</p>
                    <p><span>120/80</span>mmHg</p>
                  </li>
                  <li>
                    <p>2021.05.21</p>
                    <p>10:20:52</p>
                    <p><span>120/80</span>mmHg</p>
                  </li>
                </ul>
                <div style={{ width: 140 }}>
                  <div className="bpmBox">
                    <p>B<br />P<br />M</p>
                    <canvas width="138" height="75" id="bpmCanvas"></canvas>
                  </div>
                  <div className="stBox">
                    <p>S<br />T</p>
                    <canvas width="138" height="75" id="stCanvas"></canvas>
                  </div>
                </div>
              </div>
              <div className="botInfo">
                <p>增益：{sensitivity}mv&nbsp;&nbsp;&nbsp;&nbsp;走速：{paperSpeed}mm&nbsp;&nbsp;&nbsp;&nbsp;记录时长：10:30</p>
              </div>
            </div>
            <div style={{ width: this.state.childrenWidth }} className="chilren">
              <div className="topInfo">
                <p className="title">
                  姓名：<span>张三</span>&nbsp;&nbsp;&nbsp;&nbsp;性别：男&nbsp;&nbsp;&nbsp;&nbsp;年龄：18&nbsp;&nbsp;&nbsp;&nbsp;医院：会诊医院
                </p>
                <div className={this.isAlarm(80) ? 'bpm bpmErr' : 'bpm'} id="bpm"><span>80</span>bpm</div>
              </div>
              <div className="ecgCanvas">
                <ul style={{ width: this.state.childrenWidth - 140 }}>
                  <li>
                    <p>2021.05.21</p>
                    <p>10:20:52</p>
                    <p><span>36.4</span>C°</p>
                  </li>
                  <li>
                    <p>2021.05.21</p>
                    <p>10:20:52</p>
                    <p><span>36.4</span>C°</p>
                  </li>
                  <li>
                    <p>2021.05.21</p>
                    <p>10:20:52</p>
                    <p><span>36.4</span>C°</p>
                  </li>
                </ul>
                <div style={{ width: 140 }}>
                  <div className="bpmBox">
                    {/* <p>120<br/>80</p> */}
                    <canvas width="138" height="150" id="bloodCanvas"></canvas>
                  </div>
                </div>
              </div>
              <div className="botInfo">
                <p>增益：{sensitivity}mv&nbsp;&nbsp;&nbsp;&nbsp;走速：{paperSpeed}mm&nbsp;&nbsp;&nbsp;&nbsp;记录时长：10:30</p>
              </div>
            </div>
            <div style={{ width: this.state.childrenWidth }} className="chilren">
              <div className="topInfo">
                <p className="title">
                  姓名：<span>张三</span>&nbsp;&nbsp;&nbsp;&nbsp;性别：男&nbsp;&nbsp;&nbsp;&nbsp;年龄：18&nbsp;&nbsp;&nbsp;&nbsp;医院：会诊医院
                </p>
                <div className={this.isAlarm(80) ? 'bpm bpmErr' : 'bpm'} id="bpm"><span>80</span>bpm</div>
              </div>
              <div className="ecgCanvas">
                <ul style={{ width: this.state.childrenWidth - 140 }}>
                  <li>
                    <p>2021.05.21</p>
                    <p>10:20:52</p>
                    <p><span>36.4</span>C°</p>
                  </li>
                  <li>
                    <p>2021.05.21</p>
                    <p>10:20:52</p>
                    <p><span>36.4</span>C°</p>
                  </li>
                  <li>
                    <p>2021.05.21</p>
                    <p>10:20:52</p>
                    <p><span>36.4</span>C°</p>
                  </li>
                </ul>
                <div style={{ width: 140 }}>
                  <div className="bpmBox">
                    {/* <p>120<br/>80</p> */}
                    <canvas width="138" height="150" id="temperatureCanvas"></canvas>
                  </div>
                </div>
              </div>
              <div className="botInfo">
                <p>增益：{sensitivity}mv&nbsp;&nbsp;&nbsp;&nbsp;走速：{paperSpeed}mm&nbsp;&nbsp;&nbsp;&nbsp;记录时长：10:30</p>
              </div>
            </div>
          </div>
        </div>
        {this.state.settingModalBtn ?
          <Modal
            visible={this.state.settingModalBtn}
            onCancel={this.cancelSettingModal}
            onOk={this.settingJsonOk}
            width="800px"
            title="设置"
          >
            <div className="settingModal">
              <div className="eleWrap applyTd">
                <Tabs defaultActiveKey={this.state.activeBigKey} tabPosition='left' type="card" onChange={this.changeTabBox}>
                  <TabPane tab="心电" key="1">
                    <div><b>心率报警：</b></div>
                    <div style={{ marginTop: '10px' }}>
                      <span>白天：</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.startTime1, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'startTime1', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span style={{ marginRight: '8px' }}>到</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.endTime1, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'endTime1', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span>最低心率：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.minBpm1} onChange={this.changeBpmTime.bind(this, 'minBpm1')} min={1} />
                      <span>最高心率：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.maxBpm1} onChange={this.changeBpmTime.bind(this, 'maxBpm1')} min={1} />
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <span>夜间：</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.startTime2, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'startTime2', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span style={{ marginRight: '8px' }}>到</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.endTime2, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'endTime2', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span>最低心率：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.minBpm2} onChange={this.changeBpmTime.bind(this, 'minBpm2')} min={1} />
                      <span>最高心率：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.maxBpm2} onChange={this.changeBpmTime.bind(this, 'maxBpm2')} min={1} />
                    </div>
                  </TabPane>
                  <TabPane tab="血压" key='2'>
                    <div><b>血压报警：</b></div>
                    <div style={{ marginTop: '10px' }}>
                      <span>白天：</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.startTime1, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'startTime1', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span style={{ marginRight: '8px' }}>到</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.endTime1, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'endTime1', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span>低压：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.minBpm1} onChange={this.changeBpmTime.bind(this, 'minBpm1')} min={1} />
                      <span>高压：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.maxBpm1} onChange={this.changeBpmTime.bind(this, 'maxBpm1')} min={1} />
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <span>夜间：</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.startTime2, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'startTime2', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span style={{ marginRight: '8px' }}>到</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.endTime2, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'endTime2', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span>低压：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.minBpm2} onChange={this.changeBpmTime.bind(this, 'minBpm2')} min={1} />
                      <span>高压：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.maxBpm2} onChange={this.changeBpmTime.bind(this, 'maxBpm2')} min={1} />
                    </div>
                  </TabPane>
                  <TabPane tab="体温" key='3'>
                    <div><b>体温报警：</b></div>
                    <div style={{ marginTop: '10px' }}>
                      <span>白天：</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.startTime1, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'startTime1', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span style={{ marginRight: '8px' }}>到</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.endTime1, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'endTime1', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span>低温：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.minBpm1} onChange={this.changeBpmTime.bind(this, 'minBpm1')} min={1} />
                      <span>高温：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.maxBpm1} onChange={this.changeBpmTime.bind(this, 'maxBpm1')} min={1} />
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <span>夜间：</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.startTime2, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'startTime2', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span style={{ marginRight: '8px' }}>到</span>
                      <TimePicker
                        className="timePicker"
                        value={moment(bpmJSon.endTime2, 'HH:mm')}
                        onChange={this.changeBpmTime.bind(this, 'endTime2', 'time')}
                        defaultOpenValue={moment('00:00', 'HH:mm')}
                        format='HH:mm'
                        minuteStep={30} />
                      <span>低温：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.minBpm2} onChange={this.changeBpmTime.bind(this, 'minBpm2')} min={1} />
                      <span>高温：</span>
                      <InputNumber className="inputNumber" value={bpmJSon.maxBpm2} onChange={this.changeBpmTime.bind(this, 'maxBpm2')} min={1} />
                    </div>
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </Modal> : null
        }
      </div>
    )
  }
}
